import FeaturedClips from "components/FeaturedClips";

import StarringYou from "../StarringYou";

const LoadingSkeleton = () => {
  return (
    <>
      <FeaturedClips loading />
      <StarringYou loading />
    </>
  );
};

export default LoadingSkeleton;
